import { render, staticRenderFns } from "./privateClassEdit.vue?vue&type=template&id=57caac5c"
import script from "./privateClassEdit.vue?vue&type=script&lang=js"
export * from "./privateClassEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports